export var UrlUtil = function() {
    'use strict';

    var HASH_BANG = '_hb_';

    // ---------------------------------------------
    //
    //        Define all public methods.
    //
    // ---------------------------------------------
    var publicMethods = {
        getProtocol: function(url) {
            var protocol = publicMethods.getUrlDetails(url).protocol;
            return protocol ? protocol : 'http:';
        },
        getHost: function(url) {
            return publicMethods.getUrlDetails(url).host;
        },
        getHostname: function(url) {
            return publicMethods.getUrlDetails(url).hostname;
        },
        getPort: function(url) {
            return publicMethods.getUrlDetails(url).port;
        },
        getQuery: function(url) {
            return getQueryString(url);
        },
        addParam: function(url, paramName, paramValue) {
            url += publicMethods.getNumberOfParameters(url) > 0 ? '&' : '?';
            return url + paramName + '=' + paramValue;
        },
        getParam: function(url, paramName) {
            var results = new RegExp('[\?&]' + paramName + '=([^&#]*)').exec(url);
            if (results === null) {
                return null;
            } else {
                return results[1] || 0;
            }
        },
        getAllParams: function(url) {
            return publicMethods.getUrlDetails(url).params;
        },
        getNumberOfParameters: function(url) {
            return Object.keys(publicMethods.getAllParams(url)).length;
        },
        removeParam: function(url, paramName) {
            var startIndex = url.indexOf(paramName);
            var isFirstParam = url[startIndex - 1] === '?';

            // Do the remove if we have any parameters
            if (startIndex > -1 && (isFirstParam || url[startIndex - 1] === '&')) {
                var endIndexOfParamValue = url.substring(startIndex).search('&') + startIndex;
                var numberOfParameters = publicMethods.getNumberOfParameters(url);

                // If we only have one parameter we set the ending index at the end of the url.
                if (endIndexOfParamValue === startIndex - 1) {
                    endIndexOfParamValue = url.length;
                }

                // Remove the parameter
                var lengthOfParameterToRemove = endIndexOfParamValue - (startIndex - 1);
                var paramToRemove = url.substr(startIndex - 1, lengthOfParameterToRemove);

                url = url.replace(paramToRemove, '');

                // Replace the '&' with a '?' on the first param if we removed the first param.
                if (isFirstParam && numberOfParameters > 1) {
                    url = url.substr(0, startIndex - 1) + '?' + url.substr(startIndex);
                }
            }

            return url;
        },
        removeAllParams: function(url) {
            return url.split('?')[0];
        },
        getUrlDetails: function(url) {
            return parseURL(url);
        },
        encodeParameter: function(urlParam) {
            return urlParam.replace('#', HASH_BANG);
        },
        decodeParameter: function(urlParam) {
            return urlParam.replace(HASH_BANG, '#');
        }
    };
    
    return publicMethods;
}();



//////////////////
// WEBPACK FOOTER
// /Users/geoffsagers/dev/webcomponents/js/packages/common-account/src/util/url-util.js
// module id = 336
// module chunks = 0